import { render, staticRenderFns } from "./ClinicianPatientsList.vue?vue&type=template&id=a9422508"
import script from "./ClinicianPatientsList.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports